import React, { createContext, useContext, useRef } from 'react';

const TourContext = createContext(null);

export const TourProvider = ({ children }) => {
  const chatWidgetRef = useRef(null);

  const showFeatureTour = (featureName) => {
    if (chatWidgetRef.current && chatWidgetRef.current.autoShowFeature) {
      chatWidgetRef.current.autoShowFeature(featureName);
    }
  };

  return (
    <TourContext.Provider value={{ chatWidgetRef, showFeatureTour }}>
      {children}
    </TourContext.Provider>
  );
};

export const useTour = () => {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error('useTour must be used within TourProvider');
  }
  return context;
};
